import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Az eszköz Tablet?
 * @param ua - UserAgent.
 */
export default function isTablet (ua: string): boolean {
  return userAgentParser.isTablet(ua)
}
